(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('rmsListFilterStatusSelectionFactory', rmsListFilterStatusSelectionFactory);

    function rmsListFilterStatusSelectionFactory() {
        // singleton. Don't foresee that a page will have 2 of these for now.
        const ref = {};
        return {
            sync: function(vm) {
                ref.vm = vm;
            },
            get: function() {
                return ref.vm;
            },
            destroy: function() {
                ref.vm = null;
            }
        };
    }
})();

